export const UPDATE_LAYER_COUNT = 'fulcrum/containers/Form/PcbStackup/UPDATE_LAYER_COUNT'
